import { CustomerError } from './customer-error';
import { GolbalError } from './error-type';
const handleJsError = (event) => {
    if (!(event instanceof CustomerError)) {
        throw new CustomerError(GolbalError.GLOBAL_JS_ERROR, `GOLBAL_JS: ${event.message || 'golbal js error'}`).report();
    }
};
export const handleApiError = (event, url) => {
    if (!(event instanceof CustomerError)) {
        throw new CustomerError(GolbalError.GLOBAL_API_ERROR, `GOLBAL_API: ${event.message || url} ${event.message ? '' : '接口报错'}`, {
            requestUrl: url
        }).report();
    }
};
// 1. 全局错误监听模块
export const initErrorHandling = () => {
    // 监听同步错误
    window.addEventListener('error', (event) => {
        handleJsError(event.error || event);
    });
    // 监听未处理的 Promise 异常
    // window.addEventListener('unhandledrejection', (event) => {
    //   handleApiError(event.reason);
    // });
};
// 清理错误处理器
export const cleanup = () => {
    window.removeEventListener('error', () => handleJsError);
    // window.removeEventListener('unhandledrejection', () => handleApiError);
};
